import actionTypes from 'SRC/modules/redux/actionTypes'

export const setEquipment = (equipment) => ({
  type: actionTypes.SET_EQUIPMENT,
  payload: equipment
})
